
import { Options, Vue } from "vue-class-component";

@Options({
  data() {
    return {
      images: {
        logo: require("@images/logo_sd.png"), // logo
      },
      activeTab: 0,
      // tab切换
      tabList: [
        {
          title: "产品",
          router: "/",
        },
        {
          title: "下载",
          router: "/download",
        },
        {
          title: "帮助",
          router: "/help",
        },
      ],
      isShowNavList: false,
    };
  },

  methods: {
    switchTab(index: number) {
      console.log(this.activeTab);
      this.activeTab = index;
      this.$router.push(this.tabList[index].router);
    },
    switchNav(index: number) {
      this.activeTab = index;
      this.isShowNavList = false;
      this.$router.push(this.tabList[index].router);
    },

    gotoRegister() {
      this.$router.push("/register");
    },
  },
})
export default class Header extends Vue {}
